import { iso8601ToDate } from "@/utils/iso8601ToDate";

  export const mapPrognosisDomainToDb = (prognosis: PrognosisDomain): PrognosisDb => {
    return {
      objectId: prognosis.objectId,
      startDate: prognosis.startDate?.toISOString() || null,
      endDate: prognosis.endDate?.toISOString() || null,
      text: prognosis.text,
    };
  };

  export const mapPrognosisDbToDomain = (prognosis: PrognosisDb): PrognosisDomain => {
    return {
      objectId: prognosis.objectId,
      startDate: iso8601ToDate(prognosis.startDate),
      endDate: iso8601ToDate(prognosis.endDate),
      text: prognosis.text,
    };
  };

  export const mapPrognosisDtoToDomain = (prognosis: PrognosisDto): PrognosisDomain => {
    return {
      objectId: prognosis.objectId,
      startDate: iso8601ToDate(prognosis.startDate),
      endDate: iso8601ToDate(prognosis.endDate),
      text: prognosis.text,
    };
  };

  export const mapPrognosisDtoToDb = (prognosis: PrognosisDto): PrognosisDb => {
    return {
      objectId: prognosis.objectId,
      startDate: prognosis.startDate,
      endDate: prognosis.endDate,
      text: prognosis.text,
    };
  };

  export interface PrognosisDomain {
    objectId: string;
    startDate: Date | null;
    endDate: Date | null;
    text: string;
  }

  export interface PrognosisDto {
    objectId: string;
    startDate: string|null;
    endDate: string|null;
    text: string;
  }
  
  export interface PrognosisDb {
    objectId: string;
    startDate: string|null;
    endDate: string|null;
    text: string;
  }
